import _ from 'underscore';
import $ from 'jquery';

export default class OfferMainBasic {
  constructor($scope, $rootScope, OfferService, GeoService) {
    $scope.$watch('offer.dap_country_id', function() {
      if ($scope.offer.dap_country_id) {
        GeoService.get_cities($scope.offer.dap_country_id).then(function(data) {
          $scope.shipment_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.offer.dap_port}))
            $scope.offer.dap_port = null;
        });
      }
    });

    $scope.set_basic_data = function() {
      var count = 0;
      if ($scope.offer.origin)
        count++;
      if ($scope.offer.currency_id)
        count++;
      if ($scope.offer.dap_country_id)
        count++;
      if ($scope.offer.dap_port)
        count++;
      if ($scope.offer.delivery)
        count++;
      if ($scope.offer.packaging)
        count++;
      if ($scope.offer.payment_terms)
        count++;
      if ($scope.offer.sample_available)
        count++;
      if ($scope.offer.min_quantity_self || $scope.offer.min_quantity_ship || $scope.offer.min_quantity_truck)
        count++;
      var percentage = Math.floor(count / 9 * 100.0);
      $rootScope.$broadcast('set_sidebar_data', [1, 1, [{
        type: 'percentage',
        value: percentage
      }, null]]);
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '800px'
    };

    $scope.$watch('cfr_continent', function() {
      if ($scope.cfr_continent && $scope.cfr_continent != '') {
        var group = $('select#cfr_countries').find('optgroup[label="' + $scope.cfr_continent + '"]');
        group.find('option').each(function() {
          $scope.cfr_countries.push($(this).attr('value'));
        });
      }
    });

    $scope.$watch('dap_continent', function() {
      if ($scope.dap_continent && $scope.dap_continent != '') {
        var group = $('select#dap_countries').find('optgroup[label="' + $scope.dap_continent + '"]');
        group.find('option').each(function() {
          $scope.dap_countries.push($(this).attr('value'));
        });
      }
    });

    $scope.update_offer = function() {
      $scope.updating = true;
      $scope.form_error = '';
      $scope.offer.incoterms = {
        incoterms: _.pluck(_.filter($scope.incoterms, function(t) {
          return t.checked == true;
        }), 'id')
      };
      $scope.offer.cfr_countries = $scope.incoterms[0].checked ? $scope.cfr_countries : [];
      $scope.offer.dap_countries = $scope.incoterms[0].checked ? $scope.dap_countries : [];
      OfferService.save($scope.offer).then(function(data) {
        if (!data.success)
          $scope.form_error = data.message;
        else
          $scope.set_basic_data();
        $scope.updating = false;
      });
    };

    $scope.init = function() {
      $scope.currencies = window.currencies;
      $scope.offer = window.offer;
      $scope.incoterms = window.incoterms;
      $scope.countries = window.countries;
      $scope.cfr_countries = window.cfr_countries;
      $scope.dap_countries = window.dap_countries;
    };

    $scope.init();
  }
}

OfferMainBasic.$inject = ['$scope', '$rootScope', 'OfferService', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-main-basic.ctrl.js